module.exports = __webpack_public_path__ + "media/images/early-music-6-ef6f5e5566676b9867d5dcd091854594.jpg";